import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const TopicChildren = ({ ...rest }: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.1488 9.47163V3.61153C14.1488 2.72151 13.4273 2 12.5373 2C11.6473 2 10.9258 2.72151 10.9258 3.61153V8.44611"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16.346 12.841L18.5217 5.58862C18.7755 4.74265 18.2886 3.85248 17.4394 3.60984C16.5943 3.3684 15.7142 3.8609 15.4779 4.70743L14.1484 9.47149"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.61936 9.24984L8.6749 11.5913C9.03962 12.4003 8.6816 13.352 7.87405 13.72C7.06184 14.0901 6.10348 13.7296 5.73664 12.9159L4.6811 10.5745C4.31638 9.76541 4.6744 8.81375 5.48194 8.44573C6.29416 8.07558 7.25252 8.43613 7.61936 9.24984Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.7192 12.2615C11.9239 11.694 11.8998 11.0692 11.6518 10.5192L10.5787 8.13871C10.2181 7.33889 9.27615 6.98451 8.47782 7.34833C7.66471 7.71889 7.31887 8.68829 7.71384 9.48983L7.84948 9.76508"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.8566 17.6767L14.3487 16.6927C14.3976 16.5947 14.3461 16.4763 14.241 16.4454L10.6903 15.4011C9.97853 15.1918 9.51797 14.5038 9.59563 13.766C9.68372 12.9292 10.4284 12.3188 11.2662 12.3968L16.0542 12.8422C16.0542 12.8422 19.8632 13.4282 18.5447 17.2372C17.2262 21.0463 16.7867 22.3648 13.8566 22.3648C11.9521 22.3648 9.16855 22.3648 9.16855 22.3648H8.87555C6.52912 22.3648 4.62697 20.4627 4.62697 18.1163L4.48047 9.91211"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default TopicChildren;
